export const FAQDATA = [
  {
    question: "What services does your agency provide?",
    answer:
      "We specialize in custom web development, mobile application development, database design and management, cloud integration, and IT consulting. Our focus is on delivering scalable solutions that align with your business objectives and drive measurable results.",
  },
  {
    question: "How do you ensure data security and compliance?",
    answer:
      "We implement industry-standard security protocols including data encryption, secure authentication systems, and regular security assessments. We maintain compliance with relevant regulations such as GDPR, HIPAA, and SOC 2, depending on your industry requirements.",
  },
  {
    question: "What is your typical project delivery timeline?",
    answer:
      "Project timelines vary based on scope and complexity. Web applications typically range from 6-12 weeks, while mobile apps require 8-16 weeks. We provide detailed project roadmaps during our initial assessment and maintain transparent communication throughout development.",
  },
  {
    question: "How do you manage projects and client communication?",
    answer:
      "We follow agile development methodologies with structured sprint cycles. Each client is assigned a dedicated project manager who provides regular updates, manages timelines, and serves as your primary point of contact throughout the engagement.",
  },
  {
    question: "What development methodologies do you follow?",
    answer:
      "We primarily use Agile Scrum methodology with 2-week sprint cycles, daily standups, and regular sprint reviews. For larger projects, we incorporate DevOps practices including CI/CD pipelines, automated testing, and infrastructure as code. We also follow Test-Driven Development (TDD) and maintain comprehensive documentation throughout.",
  },
  {
    question: "How do you ensure code quality and best practices?",
    answer:
      "We enforce strict code review processes, automated testing suites, and follow industry coding standards. Our development workflow includes unit testing, integration testing, code linting, and security scanning. We use Git version control with branch protection rules and maintain test coverage above 80%.",
  },
  {
    question: "Do you provide ongoing support and maintenance?",
    answer:
      "Yes, we offer comprehensive post-launch support including system monitoring, security updates, performance optimization, and feature enhancements. We provide flexible maintenance plans tailored to your operational needs and budget requirements.",
  },
  {
    question: "What industries do you serve?",
    answer:
      "We work with clients across various sectors including healthcare, finance, e-commerce, education, and professional services. Our team adapts our technical expertise to meet the specific regulatory and operational requirements of each industry.",
  },
  {
    question: "How do you price your services?",
    answer:
      "We offer both fixed-price project quotes and hourly consulting rates depending on project scope and complexity. All pricing is transparent with detailed breakdowns provided during our initial consultation. We also offer flexible payment schedules to accommodate your budget.",
  },
  {
    question: "What is your process for starting a new project?",
    answer:
      "We begin with a comprehensive discovery session to understand your requirements, followed by technical assessment and proposal development. Once approved, we establish project timelines, communication protocols, and development milestones before beginning implementation.",
  },
];

export const WhyUsData = [
  {
    category: "Foundation",
    type: "Technical Skills",
    description:
      "Our team has years of experience building software and IT systems. We use reliable technology to solve your business problems and help you grow.",
  },
  {
    category: "Speed & Flexibility",
    type: "Fast Development",
    description:
      "We work quickly and adjust as your needs change. This approach gets your project done faster while keeping you involved throughout the process.",
  },
  {
    category: "Quality & Security",
    type: "Thorough Testing",
    description:
      "We test everything carefully to make sure it works properly and stays secure. You can trust that what we build will work reliably for your business.",
  },
  {
    category: "Easy to Use",
    type: "Simple Interfaces",
    description:
      "We design software that's easy to use and looks good. When your team or customers can use it without confusion, everyone saves time and gets better results.",
  },
  {
    category: "Ongoing Help",
    type: "Reliable Support",
    description:
      "We monitor your systems and fix problems quickly when they happen. Our support keeps everything running smoothly so you can focus on your business.",
  },
  {
    category: "Room to Grow",
    type: "Built to Scale",
    description:
      "We build systems that can handle more work as your business grows. You won't need to start over when you get bigger - everything just scales up.",
  },
  {
    category: "Good Value",
    type: "Fair Pricing",
    description:
      "You get quality work at reasonable prices. We find efficient ways to build what you need without cutting corners or overcharging.",
  },
];
